const algoliasearch = require('algoliasearch/lite');
const instantsearch = require('instantsearch.js').default;
const lib = require("../helpers/search");

import {
    searchBox,
} from "instantsearch.js/es/widgets";

import { productsConfig } from '../config/algolia';
import { panelRefinement } from "../widgets/algolia/products/tpl/panelRefinement";
import { panelNumeric } from "../widgets/algolia/products/tpl/panelNumeric";

import {
    productsCurrentRefinements,
    productsClearRefinements,
    productsConfigure,
    productsSearchResults,
} from '../widgets/algolia/products'

import {handleToggleVisibility, countDisjunctiveFacetsRefinements, countNumericRefinements} from '../helpers/search'

export default class AlgoliaProducts {
    constructor(el) {
        this.el = el
        this.setVars()
        this.init()
    }

    setVars() {
        this.appId = productsConfig.app_id;
        this.apiKey = productsConfig.api_key;
        this.index = productsConfig.index;
    }

    init() {
        this.searchClient()
    }

    searchClient() {
        // Start Algolia Client
        const algoliaClient = algoliasearch(this.appId, this.apiKey);
        // Build Search
        const search = instantsearch({
            indexName: this.index,
            routing: true,
            searchClient: algoliaClient,
            searchFunction(helper) {
                const hideIfNoFilters = document.querySelectorAll('[data-elements-hide-no-filter]')
                const hideIfFilter = document.querySelectorAll('[data-elements-hide-if-filter]');
                const hasRefinements = countDisjunctiveFacetsRefinements(helper.state.disjunctiveFacetsRefinements)
                const hasNumeric = countNumericRefinements(helper.state.numericRefinements)

                if (!hasRefinements && !hasNumeric) {
                    handleToggleVisibility(hideIfNoFilters, 'hide');
                    handleToggleVisibility(hideIfFilter, 'show');
                } else {
                    handleToggleVisibility(hideIfNoFilters, 'show');
                    handleToggleVisibility(hideIfFilter, 'hide');
                }
                helper.search()
            }
        });

        const widgetContainers = Array.from(document.querySelectorAll('[data-widget-auto]'));
        const widgetInstances = widgetContainers.map(container => {
            const { widgetAuto: type, title, label: lbl, attribute: attr, items: its } = container.dataset;
            let label = lbl || title || attr;
            let attribute = attr;
            let items;

            try {
                items = JSON.parse(its || "[]");
            } catch (e) {
                console.error(`Error parsing JSON data for widget: ${e}`);
                items = [];  // Default to an empty array if parsing fails
            }

            if (type === 'numeric') {
                return panelNumeric(container, attribute, label, items);
            } else if (type === 'refinement') {
                return panelRefinement(container, attribute, label);
            } else {
                console.error(`Unknown widget type: ${type}`);
                return null;
            }
        }).filter(widget => widget !== null);

        /*
         * Add our widgets that are imported
         * from js/widgets/algolia/products/index.js
         */
        search.addWidgets([
            searchBox({
                container: '[data-widget="products-search"]',
                placeholder: "search...",
                showReset: false,
                showSubmit: true,
                cssClasses: {
                    root: ['block mb-2 w-full bg-gray-100 border border-gray-200 flex'],
                    form: ['w-full flex'],
                    input: ['flex-1'],
                    submit: ['px-6']
                }
            }),
            productsConfigure,
            productsCurrentRefinements,
            productsClearRefinements,
            productsSearchResults,
            ...widgetInstances,
        ]);

        // Start Search
        search.start();

        search.on('render', () => {
            this.testingCallback()
        });
    }

    testingCallback() {
        // lib.reInitModules('GeneratorCard')
    }
}
